module.exports = __webpack_public_path__ + "tables4.png?12685633e0e0ca4d2bab60c5b80f1997";